export default __webpack_public_path__ + "static/media/minkymomoattd.3a30c377.jpeg";